export default __webpack_public_path__ + "static/media/Group 10873.05d4935e.svg";